$(function() {
  let dropdownEls = $('.droplinks__dropdown');

  $('.droplinks__button .btn').on('click', function() {
    let thisEl     = $(this);
    let itemEl     = thisEl.closest('.droplinks__item');
    let dropdownEl = itemEl.find('.droplinks__dropdown');

    dropdownEls.not(dropdownEl).hide();
    dropdownEl.toggle();
  });

  // close dropdowns on click outside
  $('body').on('click', function(e) {
    let targetEl = $(e.target);

    // if inside dropdown return
    if(targetEl.closest('.droplinks__dropdown').length || targetEl.is('.droplinks__dropdown')) return;

    // if dropdown button return
    if(targetEl.is('.droplinks__button .btn')) return;

    dropdownEls.hide();
  });
});